export default __webpack_public_path__ + "static/steps-d3a17d44ce7daf271b883a373229f89a.webp";